import { authService } from "../../features";
import { Button } from "../ui";

/** A quiet way out for screens that otherwise trap a signed-in person. */
export const LogOutButton = ({ className }: { className?: string }) => (
  <Button
    variant="ghost"
    className={className}
    onClick={() => void authService.signOut()}
  >
    Log out
  </Button>
);
